import { render, staticRenderFns } from "./AttachmentListe.vue?vue&type=template&id=4f76cbd7&"
import script from "./AttachmentListe.vue?vue&type=script&lang=js&"
export * from "./AttachmentListe.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports